import type { BaseColorsType } from '../types';
import type { Radius } from './radius';
import { radiusTokens } from './radius';

type Theme = {
  radius: Radius;
  fonts: {
    primary: string;
    secondary: string;
  };
  aspectRatio: {
    primary: string;
  };
  screen: {
    xs: string;
    sm: string;
    md: string;
    lg: string;
    xl: string;
    xxl: string;
  };
} & BaseColorsType;

export const baseTheme: Theme = {
  text: '--text',
  textHover: '--text-hover',
  textGrey: '--text-grey',
  textPrimary: '--text-primary',
  textBlue: '--text-blue',
  textGreen: '--text-green',
  textOrange: '--text-orange',
  textRed: '--text-red',
  textWhite: '--text-white',

  background1: '--background-1',
  background2: '--background-2',
  card: '--card',

  primary1: '--primary-1',
  primary2: '--primary-2',
  primary3: '--primary-3',

  success1: '--success1',
  success2: '--success2',
  warning1: '--warning1',
  error: '--error',
  info: '--info',
  info2: '--info2',
  purple: '--purple',

  black1: '--black-1',
  black3: '--black-3',
  black5: '--black-5',

  grey1: '--grey-1',
  grey3: '--grey-3',
  grey5: '--grey-5',
  grey6: '--grey-6',
  grey7: '--grey-7',

  white: '--white',

  elevation: '--elevation',

  buttonBg: '--button-bg',
  buttonText: '--button-text',
  buttonIcon: '--button-icon',
  buttonBorder: '--button-border',

  borderPrimary: '--border-primary',
  borderSecondary: '--border-secondary',
  borderRed: '--border-red',
  borderBlue: '--border-blue',
  borderGreen: '--border-green',
  borderOrange: '--border-orange',

  radius: radiusTokens,

  aspectRatio: {
    primary: '--aspect-ratio-primary',
  },

  fonts: {
    primary: '--font-primary',
    secondary: '--font-secondary',
  },

  screen: {
    xs: '--screen-xs',
    sm: '--screen-sm',
    md: '--screen-md',
    lg: '--screen-lg',
    xl: '--screen-xl',
    xxl: '--screen-xxl',
  },
};
